const ComboConstructorService = (function () {

        'use strict';

        //main
        function constructCombo(result){
            buildHeader(result.title, result.description);
            buildSteps(result.step);
            buildItems(result.step)
        }

        function buildHeader(title, description) {
            $(".js-combo-constructor-title").text(title);
            $(".js-combo-constructor-description").text(description);
        }


        function buildSteps(steps){
            let stepsElement = $(".js-combo-constructor-steps");
            stepsElement.empty();

            steps.forEach(element =>
                stepsElement.append(buildStep(element))
            );
        }

        function buildStep(step){
            if(step.number == 1)
                return createActiveStepNode(step);
            else
                return createOrdinaryStepNode(step);
        }

        //NODES
        function createActiveStepNode(element){
            return `<div id="step-${element.number}"  data-step="${element.number}" class="steps  steps-step  steps-step--active  js-combo-constructor-step">
                        <div class="steps  steps-badge">${element.number}</div>
                        <div class="steps  steps-title">${element.title}</div>
                    </div>`
        }

        function createOrdinaryStepNode(element){
            return `<div id="step-${element.number}" data-step="${element.number}" class="steps  steps-step  js-combo-constructor-step">
                        <div class="steps  steps-badge">${element.number}</div>
                        <div class="steps  steps-title">${element.title}</div>
                    </div>`
        }



        function buildItems(steps){
            let blocksElement = $(".js-combo-constructor-items");
            let stepIndex = 0;
            blocksElement.empty();
            steps.forEach(element =>
                element.items.forEach(item => {
                    stepIndex ++;
                    blocksElement.append(createItemNode(item, element.number, stepIndex))
                })
            );
        }

        //NODES
        function createItemNode(item, stepNumber, stepIndex){
            const priceElement =item.showPrice ? '<div class="item  item-price">' + item.price + ' ₽</div>':'';
            let stepBlock = document.createElement('div');
            stepBlock.className = `item  item-wrapper js-combo-constructor-item  js-combo-tem-step-` + stepNumber;
            stepBlock.innerHTML =
                ` 
                    <div class="item  item-container">
                        <img class="item  item-img" src="/pics/${item.picture}" alt="Товар">
                        <div class="item  item-info">
                            <div class="item  item-title">${item.title}</div>
                            <div class="item  item-description">${item.shortDescription}</div>
                            ${priceElement}
                            <div data-step="${stepNumber}" 
                                data-item="${item.id}" 
                                data-description="${item.description}" 
                                data-picture="${item.picture}" 
                                data-title="${item.title}" 
                                data-ingredient="${item.ingredient}" 
                                data-price="${item.price}" 
                                class="item  item-btn  js-choose-item-on-current-step  js-btn-on-step-${stepNumber}">
                                выбрать
                            </div>
                        </div>
                        <a id="btn-${item.id}_${stepNumber}_${stepIndex}" class="item  item-info_btn  js-show-full-info">i</a>
                        <div id="info-${item.id}_${stepNumber}_${stepIndex}" class="item  item-full_info  item-full_info">
                            <div class="item_full_info  item_full_info-title">${item.title}</div>
                            <div class="item_full_info  item_full_info-description">${item.description}</div>
                        </div>
                    </div>
             `

            return stepBlock;
        }

        return {
            constructCombo: constructCombo
        };
    }

)
();
$(ComboConstructorService.init);